import { useState, useEffect, useMemo } from 'react';
import { querySingleDoctorData } from '../../utils/functions';
import NoteStatus from './OrgSelectorComponents/NoteStatus';
import ProcessingNotes from './OrgSelectorComponents/ProcessingNotes';
import GetPatientsById from './OrgSelectorComponents/GetPatientsById';
import PatientAdditions from './OrgSelectorComponents/PatientAdditions';
import UsagePercent from './UsagePercent';

export default function DocSelector({ asyncFunction }) {
  const [docs, setDocs] = useState(null); // docs original array

  const [doc, setDoc] = useState("");
  const [docQuery, setDocQuery] = useState("");
  const [docSubmitted, setDocSubmitted] = useState(false);

  const [doctors, setDoctors] = useState(null);

  const [refinedDoctors, setRefinedDoctors] = useState(null);
  const [doctorQuery, setDoctorQuery] = useState("");

  const [copied, setCopied] = useState("");

  const [getDocData, setGetDocData] = useState(null);
  const [openDocModal, setOpenDocModal] = useState(false);

  useEffect(() => {
    if (asyncFunction) {
      (async () => {
        const fetchedDocs = await asyncFunction();

        setDocs(fetchedDocs?.sort((a, b) => a.user_name.localeCompare(b.user_name)));
      })()
    }
  }, [])

  const refinedDocs = useMemo(() => {
    if (!docQuery || !docs?.length) return null;
    return docs.filter(el =>
      el.user_name.toLowerCase().includes(docQuery.toLowerCase()) ||
      el.user_email.toLowerCase().includes(docQuery.toLowerCase())
    );
  }, [docQuery, docs]);

  useEffect(() => {
    if (docSubmitted) {
      (async () => {
        setGetDocData(await querySingleDoctorData(doc));
      })();
    }
  }, [docSubmitted])

  const handleSetDoc = (e) => {
    setDoc(e.target.value);
  }

  const resetDocForm = () => {
    setDocSubmitted(false);
    setDoc("");
    setDocQuery("");
    setGetDocData(null);
  }

  const copyToClipboard = async (e) => {
    navigator.clipboard.writeText(e.target.innerText);

    setCopied(`Successfully copied: ${e.target.innerText}`);

    setTimeout(() => {
      setCopied("");
    }, 1000)
  }

  const submitFormForDoc = async (e) => {
    e.preventDefault();

    setDocSubmitted(true);
  }

  return (
    <>
      {!docSubmitted &&
        <form className="flex gap-2 w-full mb-4 justify-between" onSubmit={submitFormForDoc}>
          <input className="w-[30%] rounded-md" type='text' value={docQuery} onChange={(e) => setDocQuery(e.target.value)} placeholder="Search" />
          <select className="w-[30%] rounded-md" placeholder='Doc' onChange={handleSetDoc} value={doc}>
            <option value="" disabled>Doctor</option>
            {refinedDocs ?
              refinedDocs && refinedDocs.map((el, i) => (
                <option key={i} value={el.user_id}>{el.user_name}</option>
              )) : docs && docs.map((el, i) => (
                <option key={i} value={el.user_id}>{el.user_name}</option>
              ))
            }
          </select>
          <button disabled={doc === ""} className="w-[30%] rounded-md border-sage-green border-[1px] text-sage-green hover:bg-sage-green hover:text-white font-semibold" type="submit">Submit</button>
        </form>
      }
      {docSubmitted &&
        <>
          {getDocData !== null ?
            <>
              <div className='flex w-full items-center justify-between'>
                <h3 className='text-[22px] font-black'>{getDocData.userName}</h3>
                <button onClick={resetDocForm} className='mb-4 rounded-md border-sage-green border-[1px] text-sage-green hover:bg-sage-green hover:text-white py-2 px-4 font-semibold'>New Doctor</button>
              </div>
              <div className='w-full max-h-[400px] relative mb-4 overflow-y-auto'>
                <table className='w-full'>
                  <thead>
                    <tr className='py-2 px-4 sticky top-0 bg-white'>
                      <th className='border-b text-left overflow-hidden text-ellipsis whitespace-nowrap'>Email</th>
                      <th className='border-b px-2 text-center'>Int</th>
                      <th className='border-b text-center'>Status</th>
                      <th className='border-b text-center'>Patients</th>
                      <th className='border-b w-auto text-center'>Sign-Up | First Note</th>
                      <th className='border-b text-center'>TP | AP</th>
                      <th className='border-b w-auto text-center'>Usage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className='py-2 px-4 hover:bg-light-purple'>
                      <td className='relative w-[20%] max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap'>
                        <button onClick={copyToClipboard}>{getDocData.userEmail}</button>
                      </td>
                      <td className='text-center'>{getDocData.accessToken ? "Yes" : "No"}</td>
                      <td className='text-center'><NoteStatus doctor_id={doc} access_token={getDocData.accessToken} doctor_name={getDocData.userName} /></td>
                      <td className='text-center'><GetPatientsById doctor_id={doc} doctor_name={getDocData.userName} /></td>
                      <td className='text-center'><ProcessingNotes doctor_id={doc} /></td>
                      <td className='text-center'><PatientAdditions doctor_id={doc} doctor_name={getDocData.userName} /></td>
                      <td className='text-center'><UsagePercent doctor_id={doc} /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {copied && (
                <div className='fixed bottom-6 right-6 max-w-[300px] bg-white shadow-knowtex-shadow rounded-md p-3'>
                  {copied}
                </div>
              )}
            </> :
            <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple text-center"></span>
          }
        </>
      }
    </>
  );
};

